import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=08f869df&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=08f869df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f869df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f869df')) {
      api.createRecord('08f869df', component.options)
    } else {
      api.reload('08f869df', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=08f869df&scoped=true&", function () {
      api.rerender('08f869df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8bYpL9Coyj52H/JS/comp/PopupDialog.vue"
export default component.exports